/* eslint-disable react/no-unstable-default-props */
/* eslint-disable unused-imports/no-unused-vars */
import React from "react";

import { Toggle, Tooltip, TooltipContent, TooltipTrigger, icons } from "../components";
import { getShortcutKeys } from "../utils/plateform";
import { cn } from "../lib/utils";

const ActionButton = React.forwardRef((props, ref) => {
	const {
		icon = undefined,
		// title = undefined,
		tooltip = undefined,
		disabled = false,
		customClass = "",
		// color = undefined,
		// loading = false,
		shortcutKeys = undefined,
		tooltipOptions = {},
		action = undefined,
		isActive = undefined,
		children,
		asChild = false,
		upload = false,
		...rest
	} = props;

	const Icon = icons[icon];
	const Comp = asChild ? Slot : Toggle;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Comp
					ref={ref}
					size="sm"
					className={cn("richtext-w-[32px] richtext-h-[32px]", customClass)}
					// pressed={isActive?.() || false}
					disabled={disabled}
					onClick={action}
					data-state={isActive?.() ? "on" : "off"}
					{...rest}
				>
					{Icon && <Icon className="richtext-w-4 richtext-h-4" />}
					{children}
				</Comp>
			</TooltipTrigger>
			{tooltip && (
				<TooltipContent {...tooltipOptions}>
					<div className="richtext-flex richtext-flex-col richtext-items-center richtext-text-center richtext-max-w-24">
						<div>{tooltip}</div>
						{!!shortcutKeys?.length && <span>{getShortcutKeys(shortcutKeys)}</span>}
					</div>
				</TooltipContent>
			)}
		</Tooltip>
	);
});

export { ActionButton };
